import React from 'react';
import 'react-toastify/dist/ReactToastify.min.css';
import {Redirect, Route, Switch} from 'react-router-dom';
import {SecureRoute} from '@okta/okta-react';
import HomeView from "./views/HomeView";
import ProfileView from "./views/ProfileView";
import OktaLoginRedirect from "./components/okta/auth/OktaLoginRedirect";
import OktaRouter from "./components/okta/OktaRouter";
import {ApiProvider} from "./services/api/ApiContext";
import MFASetupView from "./views/MFASetupView";
import {ProfileProvider} from "./contexts/ProfileContext";
import {FactorsProvider} from "./contexts/FactorsContext";
import {IdpsProvider} from "./contexts/IdpsContext";
import Header from "./components/common/Header";
import IAMSmartRedirect from "./components/iAMSmart/IAMSmartRedirect";
import IAMSmartCallback from "./components/iAMSmart/IAMSmartCallback";
import FacebookRedirect from "./components/facebook/FacebookRedirect";
import FacebookCallback from "./components/facebook/FacebookCallback";
import LinkedInRedirect from "./components/linkedin/LinkedInRedirect";
import LinkedInCallback from "./components/linkedin/LinkedInCallback";
import Footer from "./components/common/Footer";
import MainContent from "./components/common/MainContent";
import PreviousLoginView from "./views/PreviousLoginView";
import ChangePasswordView from "./views/ChangePasswordView";
import ScrollToTopHelper from "./components/common/ScrollToTopHelper";
import GoogleRedirect from "./components/google/GoogleRedirect";
import GoogleCallback from "./components/google/GoogleCallback";
import AppleRedirect from "./components/apple/AppleRedirect";
import AppleCallback from "./components/apple/AppleCallback";
import MFAEnrollView from "./views/MFAEnrollView";
import MFASetupQuestionView from "./views/MFASetupQuestionView";
import {Slide, toast, ToastContainer} from "react-toastify";
import OktaLoginCallback from "./components/okta/auth/OktaLoginCallback";
import IdpErrorView from "./views/IdpErrorView";
import {LinkIAmSmartView, LinkGoogleView, LinkLinkedInView, LinkFacebookView, LinkAppleView} from "./views/LinkOidcView";
import {LinkIAmSmartSuccessView, LinkGoogleSuccessView, LinkLinkedInSuccessView, LinkFacebookSuccessView, LinkAppleSuccessView} from "./views/LinkOidcSuccessView";

const Application = () => {
	return (
		<>
			<OktaRouter>
				<ScrollToTopHelper/>
				<Switch>
					<Route exact path={'/auth/default/login'} component={OktaLoginRedirect}/>
					<Route exact path={'/auth/default/callback'} component={OktaLoginCallback}/>

					<ApiProvider>
						<ProfileProvider>
							<IdpsProvider>
								<FactorsProvider>
									{/*<LoadingBar global />*/}

									<Route exact path={'/auth/iamsmart/login'} component={IAMSmartRedirect}/>
									<Route exact path={'/auth/iamsmart/callback'} component={IAMSmartCallback}/>
									<Route exact path={'/auth/facebook/login'} component={FacebookRedirect}/>
									<Route exact path={'/auth/facebook/callback'} component={FacebookCallback}/>
									<Route exact path={'/auth/linkedin/login'} component={LinkedInRedirect}/>
									<Route exact path={'/auth/linkedin/callback'} component={LinkedInCallback}/>
									<SecureRoute exact path={'/auth/google/login'} component={GoogleRedirect}/>
									<SecureRoute exact path={'/auth/google/callback'} component={GoogleCallback}/>
									<Route exact path={'/auth/apple/login'} component={AppleRedirect}/>
									<Route exact path={'/auth/apple/callback'} component={AppleCallback}/>

									<Route exact path={'/idp/link/iamsmart'} component={LinkIAmSmartView}/>
									<Route exact path={'/idp/link/google'} component={LinkGoogleView}/>
									<Route exact path={'/idp/link/apple'} component={LinkAppleView}/>
									<Route exact path={'/idp/link/facebook'} component={LinkFacebookView}/>
									<Route exact path={'/idp/link/linkedin'} component={LinkLinkedInView}/>
									<Header/>

									<MainContent>
										<Route exact path={'/idp/instructions'} component={IdpErrorView}/>
										<Route exact path={'/idp/link/iamsmart/success'} component={LinkIAmSmartSuccessView}/>
										<Route exact path={'/idp/link/google/success'} component={LinkGoogleSuccessView}/>
										<Route exact path={'/idp/link/facebook/success'} component={LinkFacebookSuccessView}/>
										<Route exact path={'/idp/link/linkedin/success'} component={LinkLinkedInSuccessView}/>
										<Route exact path={'/idp/link/apple/success'} component={LinkAppleSuccessView}/>

										<SecureRoute exact path={'/'} component={HomeView}/>
										<SecureRoute exact path={'/profile/details'} component={ProfileView}/>
										<SecureRoute exact path={'/profile/password'} component={ChangePasswordView}/>
										<SecureRoute exact path={'/profile/mfa'} component={MFASetupView}/>
										<SecureRoute exact path={'/profile/login'} component={PreviousLoginView}/>
										<SecureRoute exact path={'/profile/question'} component={MFASetupQuestionView}/>
										<SecureRoute exact path={'/profile'}
																 component={() => <Redirect to={{pathname: '/profile/details'}}/>}/>
										<SecureRoute exact path={'/profile/mfa/enroll/:provider/:factorType'} component={MFAEnrollView}/>
									</MainContent>

									<Footer/>
								</FactorsProvider>
							</IdpsProvider>
						</ProfileProvider>
					</ApiProvider>
				</Switch>
			</OktaRouter>
			<ToastContainer
				limit={5}
				transition={Slide}
				position={toast.POSITION.TOP_CENTER}
				hideProgressBar
				closeOnClick
			/>
		</>
	);
};

export default Application;
